var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(-48 -201.76)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 24,
    height: 24,
    transform: "translate(48 201.76)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Box_2",
    "data-name": "Box 2",
    transform: "translate(48 201.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M2,17.167a1,1,0,0,0,.615.923l8.635,3.6V10.83L6.209,8.691,2,6.937ZM3.025,5.739,6.494,7.185l8.784-3.819L12.769,2.32a2,2,0,0,0-1.538,0ZM17.2,4.166,8.4,7.991l3.594,1.525,8.783-3.859ZM22,6.758l-9.25,4.065V21.687l8.635-3.6A1,1,0,0,0,22,17.167Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.4d417101042e1350ddaf7a758f460089.svg";
export { ForwardRef as ReactComponent };